import styled from 'styled-components';
import { colors } from 'globalStyles';
import { media } from 'utils/style-utils';

export const Wrapper = styled.div`
  padding-top: 0;
  width: 500px;
  margin: 0 auto;
  ${ media.mobile_500`
    width: 100%;
    padding: 0 20px;
  `}
`;
export const Container = styled.div``;

export const Heading = styled.div`
  padding: ${({ email }) => email ? '44px 0 0 0' : '0 20px 34px'};
  text-align: left;
  ${ media.mobile`
    padding: 0 0 34px;
  `}
`;

export const PriceBox = styled.div `
  min-height: 340px;
  width: 240px;
  background-color: #FFFFFF;
  box-shadow: 0 20px 50px 0 rgba(0,0,0,0.1);
  display: inline-block;
  vertical-align: top;
  margin: 0 20px 25px 0;
  text-align: center;

  > h1 {
   color: #36474F;
   font-family: 'open_sansextrabold';
   font-size: 48px;
   line-height: 22px;
   text-align: center;
   margin: 0 0 8px;
  }
  > a {
    > button {
      height: 36px;
      width: 140px;
      border: 1px solid #007AFF;
      border-radius: 100px;
      background: #FFFFFF;
      color: ${colors.MAIN_COLOR};
      font-size: 12px;
      line-height: 17px;
      text-align: center;
      text-transform: none;
      letter-spacing: 0;
    }
  }
  ${ media.mobile`
    float: none;
    margin: 0 auto 20px;
    overflow: hidden;
  `}
`;

export const PriceBoxHead = styled.div `
  height: 45px;
  width: 240px;
  background: linear-gradient(180deg, #FFFFFF 0%, #F7F7F7 100%);
  color: ${colors.MAIN_COLOR};
  font-size: 12px;
  line-height: 48px;
  text-align: center;
  letter-spacing: 0;
  margin: 0 0  51px;
`;

export const Ul = styled.div `
  margin: 30px 0 41px;
  padding: 0 0 0 37px;
  text-align: left;
`;

export const Li = styled.div `
  padding: 0 0 0 20px;
  position: relative;
  &:before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 2px;
    width: 4px;
    height: 12px;
    border: solid #0CFF00;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }
`;


export const Tabholder = styled.div`
  > div {
    > nav {
      float: left;
      width: 100%;
      margin: 0 0 41px;
      > div {
        border-bottom: none;
        height: 0;
        padding: 0;
      }
      > ul {
        display: table;
        margin: 0;
        padding: 0;
        width: 100%;
        text-align: center;
        > li {
            display: inline-block;
            vertical-align: middle;
            float: none;
            margin: 0 0;
        ${ media.mobile`
          width: auto;
        `}
        &:first-child {
          > div {
            > div {
              > p {
                  border-radius: 3px 0 0 3px;
                  paddin: 0;
              }
            }
          }
        }
          > div {
            > div {
              > p {
                  text-align: center;
                  display: block;
                  line-height: 40px;
                  height: 36px;
                  width: 140px;
                  padding: 0;
                  border-radius:  0 3px 3px 0;
                  box-shadow: 0 4px 24px 0 rgba(0,0,0,0.1);
                  font-size: 12px;
                  line-height: 37px;
                  text-transform: capitalize;
                  text-align: center;
                  letter-spacing: 0;
                  color: #000 !importent;
                ${ media.mobile_and_tablet`
                  padding: 0px 0 0 0 !important;
                `}
              }

            }
          }
        }
      }
    }
    > div {
      display: table;
      width: 100%;
      text-align: center;
    }
  }
`;

export const PriceBoxActive = styled.div `
  min-height: 340px;
  width: 240px;
  background-color: #FFFFFF;
  box-shadow: 0 20px 50px 0 rgba(0,0,0,0.1);
  display: inline-block;
  vertical-align: top;
  margin: 0 0 25px ;
  text-align: center;

  > h1 {
   color: #36474F;
   font-family: 'open_sansextrabold';
   font-size: 48px;
   line-height: 22px;
   text-align: center;
   margin: 0 0 8px;
  }
 > a {
    > button {
      height: 36px;
      width: 140px;
      border: 1px solid #007AFF;
      border-radius: 100px;
      background: #FFFFFF;
      color: ${colors.MAIN_COLOR};
      font-size: 12px;
      line-height: 17px;
      text-align: center;
      text-transform: none;
      letter-spacing: 0;
    }
  }
  ${ media.mobile`
    float: none;
    margin: 0 auto 20px;
    overflow: hidden;
  `}
`;

export const PriceBoxHeadActive = styled.div `
  height: 45px;
  width: 240px;
  background: linear-gradient(135deg, #00B2FF 0%, #007AFF 100%);
  color: ${colors.WHITE};
  font-size: 12px;
  line-height: 48px;
  text-align: center;
  letter-spacing: 0;
  margin: 0 0  51px;
`;




// WEBPACK FOOTER //
// ./src/containers/MementoPlan/styledComponents.js